import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExporterFormatForm`

export default defineMessages({
  commaOptionLabel: {
    id: `${scope}.commaOptionLabel`,
    defaultMessage: '[ , ] comma',
  },
  periodOptionLabel: {
    id: `${scope}.periodOptionLabel`,
    defaultMessage: '[ . ] period',
  },
  formatNameLabel: {
    id: `${scope}.formatNameLabel`,
    defaultMessage: 'Format name',
  },
  formatNamePlaceholder: {
    id: `${scope}.formatNamePlaceholder`,
    defaultMessage: 'Input a format name',
  },
  dateFormatLabel: {
    id: `${scope}.dateFormatLabel`,
    defaultMessage: 'Date Formats',
  },
  decimalSymbolLabel: {
    id: `${scope}.decimalSymbolLabel`,
    defaultMessage: 'Decimal Symbol',
  },
  columnOrgTitle: {
    id: `${scope}.columnOrgTitle`,
    defaultMessage: 'Columns Organization',
  },
  columnOrgDesc: {
    id: `${scope}.columnOrgDesc`,
    defaultMessage: 'requires at least one header',
  },
  formatNameRequiredError: {
    id: `${scope}.formatNameRequiredError`,
    defaultMessage: 'Format name is required',
  },
  cancelButtonLabel: {
    id: `${scope}.cancelButtonLabel`,
    defaultMessage: 'Cancel',
  },
  saveButtonLabel: {
    id: `${scope}.saveButtonLabel`,
    defaultMessage: 'Create Format',
  },
  editButtonLabel: {
    id: `${scope}.editButtonLabel`,
    defaultMessage: 'Save Format',
  },
})
